module.exports = __webpack_public_path__ + "img/exp__2.58379415.jpg";